import { useRef, useState } from "react";
import { Download, FileUp, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/pages/admin/shared";

const TEMPLATE = "name,area,photo_url\n";

const downloadTemplate = () => {
  const url = URL.createObjectURL(new Blob([TEMPLATE], { type: "text/csv" }));
  const a = Object.assign(document.createElement("a"), { href: url, download: "committees-template.csv" });
  a.click();
  URL.revokeObjectURL(url);
};

export const BulkUpload = ({ onDone }) => {
  const ref = useRef(null);
  const [removePh, setRemovePh] = useState(true);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("remove_placeholders", removePh ? "true" : "false");
      const { data } = await api.post("/admin/committees/bulk", fd);
      toast.success(`Added ${data.created}, skipped ${data.skipped}${data.removed ? `, removed ${data.removed} placeholders` : ""}`);
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel data-testid="bulk-upload-panel">
      <h2 className="font-display text-lg font-bold text-maroon">Bulk upload (CSV)</h2>
      <p className="mt-1 text-xs text-ink-muted">Columns: <code>name, area, photo_url</code>. Names that already exist are skipped.</p>
      <label className="mt-3 flex items-center gap-2 text-sm">
        <Checkbox checked={removePh} onCheckedChange={(v) => setRemovePh(!!v)} data-testid="bulk-remove-placeholders" />
        Remove the “[Committee N]” placeholders (only those without votes)
      </label>
      <div className="mt-4 flex flex-wrap gap-2">
        <input ref={ref} type="file" accept=".csv,text/csv" className="hidden" onChange={onFile} data-testid="bulk-upload-input" />
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid="bulk-upload-btn" className="inline-flex items-center gap-2 rounded-full bg-maroon px-4 py-2 text-sm font-semibold text-ivory disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileUp className="h-4 w-4" />} Upload CSV
        </button>
        <button type="button" onClick={downloadTemplate} data-testid="bulk-template-btn" className="inline-flex items-center gap-2 rounded-full border border-gold px-4 py-2 text-sm font-semibold text-maroon">
          <Download className="h-4 w-4" /> Template
        </button>
      </div>
    </Panel>
  );
};
